module.exports = __webpack_public_path__ + "img/dpsy-banner.7c062271.png";